import { render, staticRenderFns } from "./AddData.vue?vue&type=template&id=6ad5f1b7&scoped=true"
import script from "./AddData.vue?vue&type=script&lang=js"
export * from "./AddData.vue?vue&type=script&lang=js"
import style0 from "./AddData.vue?vue&type=style&index=0&id=6ad5f1b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad5f1b7",
  null
  
)

export default component.exports